/*
React main component
*/
import TopNav from '../component/nav.jsx';
import Footer from '../component/footer.jsx';
import ToTop from '../component/toTop.jsx';
import {Grid, Row, Col} from 'react-bootstrap';

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.style = {};

    // this.state = {

    // };
  }

  render() {
    var content = (
      <div>
        <TopNav/>
        <div id="home-content">
          <div className="lander"></div>
          {/* <div className="container">
            <div className="row">
              <div className="col-sm-6 col-xs-0">
                <p className="text-center">

                  <br/>

                </p>
              </div>
              <div className="col-sm-6 col-md-6">
                <ul className="list-unstyled" id="aboutMe">
                  <li><p>A little about me.</p></li>
                  <li><p>Graduated with a B.S. in Geographic Information Science from Salisbury University Cum Laude.</p></li>
                  <li><p>Sklled coder and web developer</p></li>
                  <li><p></p></li>
                </ul>
              </div>
            </div>
        </div> */}
        <Grid className='info-grid'>
            <Row className="show-grid" fluid>
                <Col className='header' xs={12} md={4} lg={4}>
                  <h1>Carl Flint</h1>
                </Col>
                <Col className='header' xs={12} md={4} lg={4}>
                  <h4>Programmer, Web Dev, Data Analyst</h4>
                </Col>
              </Row>
        </Grid>
        </div>
        <Footer/>
        <ToTop/>
      </div>
    );

    return content;
  }
};



// WEBPACK FOOTER //
// src/js/view/home/home.jsx